import React, { useState, useEffect } from 'react';
import LoadIcon from '../../LoadIcon';
import useDebounce from '../../../utils/useDebounce';
import Link from '../../../utils/link';
import searchPosts from '../../../api/graphql/queries/searchPosts';
import Tag from './Tag';

const SEARCH_FIELDS = ['slugname', 'title'];
const MIN_INPUT_CHARACTER = 3;

const INPUT_TAG = {
  variant: 'success',
  text: {
    en: 'published',
  },
};

const SearchPostsStructure = () => {
  const [filterText, setFilterText] = useState(null);
  const [postsFromSearch, setPostsFromSearch] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const debouncedSearchTerm = useDebounce(filterText, 500);

  const getPostsBySearchParam = async (searchTerm) => {
    if (searchTerm && searchTerm.length >= MIN_INPUT_CHARACTER) {
      try {
        const posts = await searchPosts(searchTerm, 'en', false, SEARCH_FIELDS);
        if (posts && posts.length) {
          setIsLoading(false);
          setPostsFromSearch(posts);
        } else {
          setIsLoading(false);
          setPostsFromSearch([]);
        }
      } catch (error) {
        console.log('SearchPostsStructure getting posts error:', error);
      }
    } else {
      setPostsFromSearch([]);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getPostsBySearchParam(debouncedSearchTerm);
  }, [debouncedSearchTerm]);

  const handleSearchInput = (e) => {
    setIsLoading(true);
    setFilterText(e.target.value);
  };

  const renderPostsList = () => {
    if (isLoading) return <LoadIcon />;
    if (filterText && filterText.length <= MIN_INPUT_CHARACTER - 1) { return <div>please provide at least 3 characters</div>; }
    if (filterText && postsFromSearch && postsFromSearch.length === 0) {
      return <div>no posts were found for that search criteria</div>;
    }
    if (filterText && postsFromSearch && postsFromSearch.length > 0) {
      return (postsFromSearch.filter(post => !post?.slugName?.startsWith('pc')).map((post) => {
        const postCategory = post?.postCategory && post?.postCategory.length ? post?.postCategory[0] : 'blank';
        return (
          <Link
            key={`/cms/structure/${postCategory}/${post?.slugName}`}
            className="text-black"
            to={`/cms/structure/${postCategory}/${post?.slugName}`}
          >
            <div className="flex cursor-pointer items-center py-4 px-2 border-b border-dashed border-gray200 hover:bg-gray200 hover:text-white">
              <span className="font-bold">
                {`${post?.postDescription && post?.postDescription.title && post?.postDescription.title.en ? `${post?.postDescription.title.en} --- ` : ''} `}
              </span>
              <span>
                {`${post?.slugName}`}
              </span>
              {post?.active
                ? <Tag text={INPUT_TAG.text.en} variant={INPUT_TAG.variant} /> : null }
            </div>
          </Link>
        );
      }));
    }
    return null;
  };

  return (
    <div className="w-3/4">
      <input className="py-2 px-2 w-full outline-none bg-gray200 hover:bg-white focus:bg-white hover:shadow-outline hover:border-gray200 focus:shadow-outline focus:border-gray200" type="text" onChange={handleSearchInput} placeholder={`Search posts, please provide at least ${MIN_INPUT_CHARACTER} characters`} />

      {filterText
        ? <div className="mt-2 py-4 px-2 bg-white absolute w-3/4">{renderPostsList()}</div>
        : null
        }

    </div>
  );
};

export default SearchPostsStructure;
